import RiskAssessmentWaypoint from './RiskAssessmentWaypoint'

export default RiskAssessmentWaypoint
